// extracted by mini-css-extract-plugin
export default {"inputForm":"PreferenceTypeTwo_inputForm__i6hHI"};